import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CoachCard } from "@/components/coaches/CoachCard";
import { fetchActiveCoaches } from "@/lib/coachesQueries";

export function CoachesTeaser() {
  const { data } = useQuery({ queryKey: ["coaches", "teaser"], queryFn: () => fetchActiveCoaches() });
  const coaches = (data ?? []).slice(0, 3);
  if (coaches.length === 0) return null;

  return (
    <section className="mt-20">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 text-2xl font-bold tracking-tight md:text-3xl">
            <Users className="h-6 w-6 text-primary" /> Live coaches, ready when you are
          </h2>
          <p className="mt-1 text-muted-foreground">
            Real AGES members helping others build wealth, health, and impact.
          </p>
        </div>
        <Button asChild variant="outline">
          <Link to="/coaches">See all <ArrowRight className="ml-1 h-4 w-4" /></Link>
        </Button>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {coaches.map((c) => <CoachCard key={c.user_id} coach={c} />)}
      </div>
    </section>
  );
}
